import { defineComponent as _defineComponent } from 'vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { onMounted, ref, watch } from 'vue'
import { mdiMagnify } from '@mdi/js'
import { eventApi, EventDB, EventPeriod, EventSearchParams } from '@/enitites/event'
import { EventPreviewCompactCard } from '@/features/event-card'
import { useThrottleFn } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchEvents',
  emits: ["changed-tab"],
  setup(__props, { emit }: { emit: ({
  (e: 'changed-tab', tab: EventPeriod): void
}), expose: any, slots: any, attrs: any }) {



const tabs = ref(0)
const tabsList = ref<
  {
    name: EventPeriod
    title: string
    amount: number
  }[]
>([
  { name: 'now', title: 'Now', amount: 0 },
  { name: 'future', title: 'Future', amount: 0 },
  { name: 'past', title: 'Past', amount: 0 },
])

const payload = ref<EventSearchParams>({
  pageNumber: 0,
  pageSize: 50,
  keyword: '',
  sortBy: 'date-asc',
  tab: tabsList.value[0].name,
  orgIds: [],
})

async function getAvailableTabs() {
  const availableTabs = await eventApi.getEventsAvailableTabs({
    userId: undefined,
    orgId: undefined,
  })
  tabsList.value = tabsList.value.map((tabItem) => ({
    ...tabItem,
    amount: availableTabs[tabItem.name as keyof typeof availableTabs],
  }))
}

const events = ref<EventDB[]>([])
const infiniteId = ref(+new Date())

function resetPayload() {
  payload.value.pageNumber = 0
  events.value = []
  infiniteId.value += 1
}

async function getEvents() {
  payload.value.tab = tabsList.value[tabs.value].name
  resetPayload()
  emit('changed-tab', payload.value.tab)
}

const sortBy = ref('date')
const sortDirection = ref(true)
const loading = ref(false)

const defaultSortDirections: Record<EventPeriod, boolean> = {
  now: true,
  past: false,
  future: true,
  draft: false,
}

watch(
  () => payload.value.tab,
  (tab) => {
    sortDirection.value = defaultSortDirections[tab]
    payload.value.tab = tab
    resetPayload()
    payload.value.keyword = ''
  }
)

async function infiniteHandler($state: { complete: () => void; loaded: () => void }) {
  payload.value.sortBy = `${sortBy.value}-${sortDirection.value ? 'asc' : 'desc'}`
  loading.value = true
  const data = await eventApi.getEvents(payload.value)
  loading.value = false
  if (!data || typeof data === 'string') return
  events.value.push(...data)
  payload.value.pageNumber += 1
  if (data.length < payload.value.pageSize) $state.complete()
  else $state.loaded()
}

const throttledResetPayload = useThrottleFn(resetPayload, 1200)

onMounted(() => {
  getAvailableTabs()
})

return { __sfc: true,emit, tabs, tabsList, payload, getAvailableTabs, events, infiniteId, resetPayload, getEvents, sortBy, sortDirection, loading, defaultSortDirections, infiniteHandler, throttledResetPayload, BKInput, mdiMagnify, EventPreviewCompactCard }
}

})